import { gql } from "@apollo/client";

export default gql`
  mutation RemoveGroup($groupId: ObjectId!) {
    removeGroupById(id: $groupId)
  }
`;
